__turbopack_context__.v({
  "className": "arminfont_b5c8c61e-module__5sxW6q__className",
  "variable": "arminfont_b5c8c61e-module__5sxW6q__variable",
});
